import type { ButtonHTMLAttributes } from "react";
import { Link } from "react-router-dom";

import { Button } from "./Button";

export function OpenIcon({ className }: { className?: string }) {
  return (
    <svg
      className={["ui-open-icon", className].filter(Boolean).join(" ")}
      viewBox="0 0 16 16"
      width="16"
      height="16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.35"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M4.75 11.25 11.25 4.75M6.5 4.75h4.75v4.75" />
    </svg>
  );
}

export function OpenLink({
  to,
  label,
  showLabel = false,
  className,
}: {
  to: string;
  label: string;
  showLabel?: boolean;
  className?: string;
}) {
  return (
    <Link
      to={to}
      className={[
        "ui-open-action",
        showLabel ? "ui-open-action--labeled" : "ui-open-action--icon",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      aria-label={showLabel ? undefined : label}
      title={showLabel ? undefined : label}
    >
      {showLabel && <span>{label}</span>}
      <OpenIcon />
    </Link>
  );
}

export function OpenButton({
  label,
  loading = false,
  className,
  ...props
}: Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children" | "aria-label"> & {
  label: string;
  loading?: boolean;
}) {
  return (
    <Button
      {...props}
      tone="quiet"
      size="sm"
      className={["ui-open-action", "ui-open-action--icon", className]
        .filter(Boolean)
        .join(" ")}
      aria-label={loading ? `${label}, opening` : label}
      title={label}
      loading={loading}
    >
      {!loading && <OpenIcon />}
    </Button>
  );
}
